import { TagDesignTokens } from '@primeuix/themes/types/tag';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tDeep, t, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tag/index.ts
const tag = componentCommon.tag;
const tagCs = componentColorScheme.tag;
const d = tDeep(tag);

export const TagTelekomDT: TagDesignTokens = {
  root: {
    fontSize: t(tag.font.size),
    fontWeight: tNum(tag.font.weight),
    gap: t(tag.gap),
    padding: `${d.padding.y} ${d.padding.x}`,
    borderRadius: t(tag.border.radius),
    roundedBorderRadius: t(tag.rounded.border.radius),
  },
  icon: {
    size: t(tag.icon.size),
  },
  colorScheme: {
    light: {
      primary: {
        background: t(tagCs.primary.background),
        color: t(tagCs.primary.color),
      },
      secondary: {
        background: t(tagCs.secondary.background),
        color: t(tagCs.secondary.color),
      },
      success: {
        background: t(tagCs.success.background),
        color: t(tagCs.success.color),
      },
      info: {
        background: t(tagCs.info.background),
        color: t(tagCs.info.color),
      },
      warn: {
        background: t(tagCs.warn.background),
        color: t(tagCs.warn.color),
      },
      danger: {
        background: t(tagCs.danger.background),
        color: t(tagCs.danger.color),
      },
      contrast: {
        background: t(tagCs.contrast.background),
        color: t(tagCs.contrast.color),
      },
    },
  },
};
